import Pusher from 'pusher-js';

const pusher =  new Pusher("584bdc08e9d303fe84e5", {
    cluster: 'eu'
})
// prod
// const pusher =  new Pusher("930cf54621c7081a73a7", {
//     cluster: 'eu'
// })
export default pusher;